import "./Home.module.css";
import NavigationMenuSection from "@/reusable_sections/Header";
import BrandCoreVision from "./sections/BrandCoreVision";
import Hero from "./sections/Hero";
import SimpleThreeStepsToStartExperience from "./sections/SimpleThreeStepsToStartExperience";
import ContactRuishengHearingExperts from "./sections/ContactRuishengHearingExperts";
import HomeCareCoreValues from "./sections/HomeCareCoreValues";
import SubsidyApplicationGuide from "./sections/SubsidyApplicationGuide";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationMenuSection />
      <BrandCoreVision />
      <Hero />
      <SimpleThreeStepsToStartExperience />
      <ContactRuishengHearingExperts />
      <HomeCareCoreValues />
      <div id="subsidy">
        <SubsidyApplicationGuide />
      </div>
      <Footer />
    </div>;
}